﻿import { trucksOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("truck"),
  key: "truckTable",
  keyDetail: "truckDetail",
  endpoint: "trucks",
  operations: trucksOps,
  roleView: [ROLE.TRUCK_VIEW, ROLE.TRUCK_ADMIN],
  roleAdmin: [ROLE.TRUCK_ADMIN],
  singularName: (t) => t("Truck"),
  name: (t) => t("Trucks"),
  syncCustomerFilter: true,
});

export default conf;
